<template>
  <!-- eslint-disable -->
  <div ref="inventario_entrada">
    <b-overlay ref="overlay_index" variant="white" :show="showLoading" spinner-variant="primary" blur="0" opacity=".75" rounded="sm">
      <b-card ref="card_tabs">
        <formulario class="mt-2 pt-75" />
      </b-card>
    </b-overlay>
  </div>
</template>

<script>
/* eslint-disable */
import Vue from 'vue'
import formulario from './entrada-formulario.vue'
import detalle from './entrada-detalle.vue'
import { BootstrapVue, BootstrapVueIcons, VBTooltip } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
export default {
  directives: {
    'b-tooltip': VBTooltip,
    Ripple
  },
  data() {
    return {
      showLoading: false,
      records: [],
      tabIndex: 0
    }
  },
  mounted(){
    //this.$refs.tabs_mov_int.currentTab = this.tabIndex
    this.$router.beforeEach((to, _, next) => {
      if (to.name != 'detalle-mov' && to.name != 'editar-mov' && to.name != 'stock-entrada') {
        this.$store.commit('back/setIndexTabMI', 0)
      }
      return next()
    })
  },
  components:{
    formulario,
    detalle,
  }
}
</script>

<style></style>
